import { render, staticRenderFns } from "./autograph.vue?vue&type=template&id=473552d8&scoped=true&"
import script from "./autograph.vue?vue&type=script&lang=js&"
export * from "./autograph.vue?vue&type=script&lang=js&"
import style0 from "./autograph.vue?vue&type=style&index=0&id=473552d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473552d8",
  null
  
)

export default component.exports